import ACCOUNTS_NOTES from './accountsNotes';
import AUTOMOBILE from './automobiles';
import CASH_ON_HAND from './cashOnHand';
import IRAS from './iras';
import LIFE_INSURANCES from './lifeInsurances';
import OTHER from './other';
import OTHER_PROPERTIES from './otherProperties';
import REAL_ESTATE from './realEstate';
import SAVINGS_ACCOUNTS from './savingsAccounts';
import STOCK_AND_BONDS from './stockAndBonds';


export default {
  accounts_notes: ACCOUNTS_NOTES,
  automobiles: AUTOMOBILE,
  cash_on_hand: CASH_ON_HAND,
  iras: IRAS,
  life_insurances: LIFE_INSURANCES,
  other: OTHER,
  other_properties: OTHER_PROPERTIES,
  real_estate: REAL_ESTATE,
  savings_accounts: SAVINGS_ACCOUNTS,
  stocks_and_bonds: STOCK_AND_BONDS,
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/index.js